import { isArray } from '@mechhive/helpers';
import clsx from 'clsx';
import type { ComponentProps, PropsWithChildren } from 'react';
import { Icon } from '../Icon';

export type MenuAccessoryProps = PropsWithChildren<{
  className?: string;
}>;

export const MenuAccessory = ( { className, children }: MenuAccessoryProps ) => {
  const Items = isArray( children ) ? children : [ children ];
  const Label = Items.find( i => i?.type?.['displayName'] === 'MenuAccessoryLabel' );
  const _Icon = Items.find( i => i?.type?.['displayName'] === Icon.displayName )

  return (
    <div className={ clsx(
      'flex flex-row items-center gap-1',
      className
    ) }>
      {Label}
      {_Icon}
    </div>
  )
}
MenuAccessory.displayName = 'MenuAccessory';

type MenuAccessoryIconProps = {
  className?: string;
} & ComponentProps<typeof Icon>

export const MenuAccessoryIcon = ( { className, ...iconProps }: MenuAccessoryIconProps ) => {
  return (
    <Icon
      className={ clsx(
        className
      ) }
      { ...iconProps }
    />
  )
}
MenuAccessoryIcon.displayName = 'MenuAccessoryIcon';

type MenuAccessoryLabelProps = PropsWithChildren<{
  className?: string;
}>;

export const MenuAccessoryLabel = ( { className, children }: MenuAccessoryLabelProps ) => {
  return (
    <p className={ clsx(
      'text-sm leading-[14px]',
      className
    ) }>
      { children }
    </p>
  )
}
MenuAccessoryLabel.displayName = 'MenuAccessoryLabel';
